import './style/index.less';
import Nickname from './Nickname';

export default Nickname;
